import React, { useMemo } from 'react';

import { useEditorContext } from 'src/store/editor';
import { generateJourneyShareUrl } from 'src/utils/journey';
import { useCurrentOrganization } from 'src/store/organization';
import { PreviewStrongIcon } from 'src/monet/icons';

/**
 * TODO: https://linear.app/journey/issue/J-1624/remove-button-tags-surrounded-by-a-tags
 */
export const EditorHeaderPreviewButton = () => {
  const journey = useEditorContext((state) => state.journey);
  const currentOrganization = useCurrentOrganization((state) => state.currentOrganization);

  const journeyShareUrl = useMemo(() => {
    return generateJourneyShareUrl(currentOrganization, journey);
  }, [currentOrganization, journey]);

  if (!journey) return null;

  return (
    <a href={journeyShareUrl} className='flex' target='_blank' rel='noopener noreferrer'>
      <button type='button' className='has-hover py-[9px] px-md'>
        <div className='flex items-center space-x-xs'>
          <PreviewStrongIcon />
          <span className='text-bedrock-p-strong'>{journey?.is_template ? 'Preview Template' : 'Preview'}</span>
        </div>
      </button>
    </a>
  );
};
